// E-mail validation pattern taken from https://emailregex.com/
const emailPattern = new RegExp('(?:[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:' +
	'[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0' +
	'-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25' +
	'[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[' +
	'\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])');

/**
 * Check if the provided string is a valid e-mail address.
 *
 * @param s The string to check.
 * @returns boolean `true` when the provided string is a valid e-mail address. `false` otherwise.
 */
const isValidEmailAddress = (s: string) => s && emailPattern.test(s);

export {
	isValidEmailAddress
};
